<ul [ngClass]="ulClasses">
    @for (route of loopNavRoutes; track route) {
        @if (navService.shouldShowRouteLink(route, navRoutes)) {
            <li
                #linkLi
                [class.small-screen-only]="route.isInUserNav"
                [routerLinkActive]="['link-active']"
                [class.link-active]="route.id === currForceSelect"
                [routerLinkActiveOptions]="{ exact: route.exact }"
            >
                <a
                    class="d-block"
                    [queryParams]="route.queryParams"
                    [routerLink]="[route.path]"
                    (click)="clickLink()"
                >
                    {{ route.name }}
                </a>
            </li>
        }
        @if (route && route.children && !route.hasSideNav) {
            <li
                [class.small-screen-only]="route.isInUserNav"
                class="dropdown"
                [ngClass]="{
                    'bottom-arrow':
                        isRoot &&
                        !isSecondary &&
                        (currSelectedNavMenuItem.startsWith(route.id) ||
                            currOpenSecondaryNavMenu.startsWith(route.id)),
                    'dropdown-submenu': !isRoot,
                }"
            >
                <a
                    class="d-block dropdown-toggle"
                    style="white-space: nowrap"
                    href="#"
                    (click)="clickDropdown(route.id)"
                >
                    {{ route.name }}
                </a>
                <pcg-top-click-nav
                    [isRoot]="false"
                    [menuItemId]="route.id"
                    [navRoutes]="route.children"
                ></pcg-top-click-nav>
            </li>
        }
    }

    @if (isRoot && sec.isLoggedOn()) {
        <li
            class="dropdown"
            [class.bottom-arrow]="currSelectedNavMenu?.parentNav?.isInUserNav"
        >
            @if (user) {
                <a
                    href="#"
                    (click)="clickDropdown('user')"
                    class="d-block small-screen-only dropdown-toggle"
                >
                    {{ user.firstName }} {{ user.lastName }}
                </a>
            }
            <ul
                class="dropdown-menu top-nav-bg"
                [class.nav-open]="userNavOpen"
            >
                <li
                    [routerLinkActive]="['link-active']"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                    <a
                        (click)="clickLink()"
                        class="d-block small-screen-only"
                        [routerLink]="'/edit-user/' + user.id"
                    >
                        My Profile
                    </a>
                </li>
                <li [routerLinkActive]="['link-active']">
                    <a
                        (click)="clickLink()"
                        class="d-block small-screen-only"
                        routerLink="/help"
                    >
                        Help
                    </a>
                </li>
                <li>
                    <a
                        class="d-block small-screen-only"
                        href="#"
                        (click)="logout(); clickLink()"
                    >
                        Logout
                    </a>
                </li>
            </ul>
        </li>
    }

    @if (isRoot && sec.isLoggedOn()) {
        <li>
            <a
                class="d-block small-screen-only"
                href="#"
                (click)="openSearch()"
            >
                Search...
            </a>
        </li>
    }
</ul>
